import { Modal, Button } from "antd";
import styled from "styled-components";
import useModal from "../../hooks/useModal";
import { useTableForm } from "../../hooks/useTableForm";

function DeleteModalTable() {

  const { isModalDeleteOperacoes, setIsModalDeleteOperacoes, form } = useModal();
  const { indexId, rows, setIndex, setTempIdDeleteds, tempIdDeleteds, updateTableRow } = useTableForm();

  const toDelete = rows.find((_, index) => index === indexId);

  function reajustarSequencia(itens: any[], sequenciaRemovida: number) {
    const aindaExiste = itens.some(item => item.sequencia === sequenciaRemovida);

    if (aindaExiste) {
      return itens;
    }

    const extrairSequenciaVinculada = (vinculo?: string): number | null => {
      if (!vinculo) return null;
      const match = vinculo.match(/\d+/);
      return match ? Number(match[0]) : null;
    };

    return itens.map(item => {
      const novoItem = { ...item };

      if (novoItem.sequencia > sequenciaRemovida) {
        novoItem.sequencia = novoItem.sequencia - 1;
      }

      if (novoItem.rules?.informarOperacaoVinculada && novoItem.vinculo) {
        const seqVinculada = extrairSequenciaVinculada(novoItem.vinculo);

        if (seqVinculada !== null && seqVinculada > sequenciaRemovida) {
          novoItem.vinculo = `Operação ${seqVinculada - 1}`;
        }
      }

      return novoItem;
    });
  }

  async function handleDelete() {
    if (!toDelete) return;

    const itensFiltrados = rows.filter((_: any, i: number) => i !== indexId);
    let itensAtualizados = reajustarSequencia(itensFiltrados, toDelete.sequencia);

    form.setFieldsValue({ itens: itensAtualizados });

    updateTableRow(itensAtualizados);

    tempIdDeleteds.push(toDelete.planoOperacionalOperacaoId!);
    setTempIdDeleteds(tempIdDeleteds);

    closedModal();
  }

  function closedModal() {
    setIsModalDeleteOperacoes(false);
    setIndex(-1);
  }

  return (
    <CustomModal
      title="Excluir Operação do Planejamento Operacional"
      visible={isModalDeleteOperacoes}
      onCancel={closedModal}
      maskClosable={false}
      mask={false}
      zIndex={9999}
      destroyOnClose
      footer={
        <>
          <Button
            size="large"
            onClick={closedModal}
            style={{ borderRadius: 8 }}
          >Cancelar</Button>
          <Button
            size="large"
            type="primary"
            danger
            onClick={handleDelete}
            style={{ borderRadius: 8 }}
          >Confirmar</Button>
        </>
      }
    >
      <p>Deseja excluir a operação {toDelete?.sequencia} {toDelete?.operacao?.text} ?</p>
    </CustomModal>
  );
}

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #ff4d4f;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
  
`;

export default DeleteModalTable;
